import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "./data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-sm transition-shadow duration-300 border-b ${
        scrolled ? "shadow-sm border-gray-200" : "border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#top" data-testid="header-logo-link" className="shrink-0"><Logo /></a>

          <nav className="hidden lg:flex items-center gap-8 xl:gap-10">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                className="text-sm font-medium text-[#001E52]/90 hover:text-[#FE6A04] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:block">
            <a
              href="#contact"
              data-testid="header-quote-cta"
              className="inline-flex items-center rounded-md px-6 py-2.5 bg-[#FE6A04] text-white text-sm font-semibold shadow-sm hover:bg-[#e15e02] hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
            >
              Get a Quote
            </a>
          </div>

          <button
            className="lg:hidden text-[#001E52]"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-200 bg-white px-4 py-4 space-y-1" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-base font-medium text-[#001E52]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="block text-center mt-3 rounded-md px-6 py-3 bg-[#FE6A04] text-white font-semibold shadow-sm hover:bg-[#e15e02] transition-colors"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
};
